import gsap from 'gsap';


export default class GNav{

    constructor(){
        this.$gnav = null;
        this.$body = null;
        this._init();
        this._ui();
    }


    _init(){
        this.$body = document.body;
        this.$gnav = document.querySelector('.l-gnav');
    }


    _ui(){

        document.querySelector('.js-btnNav').addEventListener('click', ()=>{
            this.$gnav.classList.add('-active');
            this.$body.classList.add('-lock');
        });

        document.querySelector('.js-nav-close').addEventListener('click', ()=>{
            this.$gnav.classList.remove('-active');
            this.$body.classList.remove('-lock');
        });

        [...document.querySelectorAll('.js-gnavLink')].forEach($a=>{

            $a.addEventListener('click', (e)=>{
                e.preventDefault();
                this.$gnav.classList.remove('-active');
                this.$body.classList.remove('-lock');
                this._setScroll($a.getAttribute('href'));
            });
        });
    }

    _setScroll(target){
        const $target = document.querySelector(target);
        if(!$target) return false;

        const adjust = parseInt($target.getAttribute("data-adjust"));
        const targetAdjust = adjust ? adjust : 0;
        let targetPos = parseInt(this._getAbsoluteTop($target)) - targetAdjust;
        targetPos = targetPos < 0 ? 0 : targetPos;

        gsap.to([document.querySelector("html"), document.querySelector("body")], { duration: 0.7, scrollTop: targetPos, ease: "power2.out" });
    }

    _getAbsoluteTop(_selector) {
        return _selector.getBoundingClientRect().top + window.pageYOffset;
    }
}